import { useAuth } from 'components/Auth/AuthContext';
import { UserRoleValue } from 'types/api';

export function useRoleCheck(role: string): boolean {
  const auth = useAuth();

  return auth.hasRole(role);
}

export function useAdminRole (): boolean {
  return useRoleCheck(UserRoleValue.Admin);
}

export function useDeployerRole (): boolean {
  return useRoleCheck(UserRoleValue.Deployer);
}

export function useUserRole (): boolean {
  return useRoleCheck(UserRoleValue.User);
}
